import { IMembership } from '@app/core/state/entities/membership/membership.entity';
import { defaultEntityState } from '@app/core/state/entities/entity';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '@app/core/state/entities/entity.helpers';
import { createReducer, on } from '@ngrx/store';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const membershipEntityReducer = createReducer(
  defaultEntityState<IMembership>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.registered,
    projectDetailActions.projectMembershipGroupsUpdated,
    projectDetailActions.projectMembershipsGroupBulkUpdatedSuccessfully,
    (state, props) => mergeEntityState(entityKey.memberships, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
